function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  id: "replay_circle_filled_black_24dp",
  transform: "translate(19 9)"
}, React.createElement("g", {
  id: "Group_3507",
  "data-name": "Group 3507",
  transform: "translate(-21 -11)"
}, React.createElement("path", {
  id: "Path_8999",
  "data-name": "Path 8999",
  d: "M11,2a9,9,0,1,0,9,9A9,9,0,0,0,11,2Zm5.4,9.666a5.4,5.4,0,0,1-10.692.846A.893.893,0,0,1,6.59,11.45h0a.9.9,0,0,1,.882.72A3.6,3.6,0,1,0,11,7.85V9.461a.445.445,0,0,1-.765.315L7.715,7.265a.446.446,0,0,1,0-.639l2.511-2.511A.455.455,0,0,1,11,4.439V6.05A5.409,5.409,0,0,1,16.4,11.666Z",
  fill: "#fff"
})));

var SvgReplays = function SvgReplays(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgReplays, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/replays.09d7038c.svg";
export { ForwardRef as ReactComponent };